import logo from './logo.svg';
import './App.css';
import AdminUi from './components/AdminUi';

function App() {
  return (
    <>
    <AdminUi/>
    </>
  );
}

export default App;
